export const enum TX_NOTIFICATION_TYPES {
  STANDARD_TX = 'STANDARD_TX',
  CONFIRMATION_TX = 'CONFIRMATION_TX',
  CANCELLATION_TX = 'CANCELLATION_TX',
  SETTINGS_CHANGE_TX = 'SETTINGS_CHANGE_TX',
  NEW_SPENDING_LIMIT_TX = 'NEW_SPENDING_LIMIT_TX',
  REMOVE_SPENDING_LIMIT_TX = 'REMOVE_SPENDING_LIMIT_TX',
  SPENDING_LIMIT_TX = 'SPENDING_LIMIT_TX',
}
